// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"3acc5e6f","684":"3808dba4"}[chunkId] + ".chunk.js";
};